exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".site-modal{display:flex;align-items:center;justify-content:center}.site-modal .modal-content{position:absolute;width:800px;background-color:#fff;border:2px solid #e5e5e5;box-shadow:0px 1px 2px rgba(0,0,0,.1607843137);padding:20px}.site-modal .modal-content .modal-head .modal-exit{display:flex;justify-content:center;cursor:pointer}.site-modal .modal-content .modal-body-content{padding-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Common/SiteModal.scss
// module id = 1356
// module chunks = 101